"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.common_en_us = void 0;
function common_en_us() {
    return {
        "actions.close": "close",
        "actions.save": "save",
        "actions.cancel": "cancel",
        "actions.create": "create",
        "actions.yes": "yes",
        "actions.no": "no",
        "actions.dialogdismiss": "close",
        "actions.add": "add",
        "actions.edit": "edit",
        "actions.delete": "delete",
        "actions.ok": "ok",
        "actions.search": "search",
        "actions.reset": "reset",
        "actions.skip": "skip",
        "actions.print": "print",
        "actions.refresh": "refresh",
        "actions.select": "select",
        "actions.done": "done",
        "actions.more": "more",
        "actions.enable": "enable",
        "actions.disable": "disable",
        "actions.accept": "accept",
        "actions.download": "download",
        "actions.upload": "upload",
        "actions.showall": "show all",
        "actions.submit": "submit",
        "actions.addnote": "add note",
        "actions.learn": "Learn more!",
        "actions.continue": "continue",
        "actions.disconnect": "disconnect",
        "actions.open": "open",
        "actions.donotshowagain": "Do not show again!",
        "actions.import": "import",
        "actions.check": "check",
        "actions.openinnewwindow": "open in new window",
        "actions.restore": "Restore",
        "errors.notfound": "Not found",
        "errors.nodata": "No data available",
        "errors.generic": "An unexpected error occurred",
        "errors.tryagainlater": "An error occurred, please try again later.",
        "errors.invalidmail": "Please enter a valid e-mail address (e.g. test@gmail.com)",
        "errors.invalidphonenumber": "Please enter a valid phone number (e.g. +49896121247)",
        "errors.invalidurl": "Please enter a valid URL",
        "errors.http.400": "The request was invalid",
        "errors.http.401": "You are not logged in",
        "errors.http.403": "Sorry, you don't have access to this resource",
        "errors.http.404": "Sorry, the requested resource does not exist",
        "errors.http.409": "The resource exists already",
        "errors.http.500": "Something went wrong",
        "errors.http.503": "The service is not available at this moment",
        "errors.unreachable.title": "Error",
        "errors.unreachable.message": "The system is currently unavailable, please try again in a few moments!",
        "errors.access.nottheowner": "You're not the owner of this resource",
        "errors.validations.validating_field": "Input",
        "errors.validations.validation_failed_message": "Errors occured while validating your input!",
        "errors.validations.required": "required",
        "errors.validations.isalpha": "must contain only lowercase letters (a-z)",
        "errors.validations.isemail": "must be a valid E-Mail",
        "errors.validations.islowercase": "all letters must be lowercase",
        "errors.validations.isurlconform": "Maximum of 45 letters. All letters must be Url conform (a-Z 0-9 _\\-~)",
        "errors.validations.length": "must have a min length of 3 letters",
        "errors.validations.minlength": "must have a minimum length of ${requiredLength} characters",
        "errors.validations.maxlength": "can't be longer than ${maxLength} characters",
        "errors.validations.min": "must have a minimum of ${min}",
        "errors.validations.max": "can't be bigger than ${max}",
        "errors.validations.minitems": "provide at least ${min} elements",
        "errors.validations.maxitems": "provide at most ${max} elements",
        "errors.validations.isstring": "must be a string",
        "errors.validations.isint": "must be a number",
        "errors.validations.isobject": "must be a JavaScript object",
        "errors.validations.isjsonschema7": "must be a valid JSONSchema7",
        "errors.validations.matches": "must match the pattern",
        "errors.validations.isdefined": "must be defined",
        "errors.validations.pattern": "must follow this pattern: ${requiredPattern}",
        "errors.validations.iconerror": "must be a valid icon",
        "errors.validations.invalidvalue": "must be one of the proposed values",
        "errors.validations.enum": "must be one of these: ${enumValues}",
        "errors.validations.type": "type must be ${type}",
        "errors.user.email_already_exists": "This E-Mail is already registered",
        "errors.user.invalid_password_uppercasemissing": "Invalid Password: Uppercase character is missing",
        "errors.user.invalid_password_lowercasemissing": "Invalid Password: Lowercase character is missing",
        "errors.user.invalid_password_notatleast8characterslong": "Invalid Password: Please provide at least 8 characters",
        "errors.user.invalid_password_nospecialcharacter": "Invalid Password: Please provide a special character like ! ? # or spaces",
        "errors.user.token_required": "No token received",
        "errors.user.invalid_password": "Invalid Password",
        "errors.user.user_not_found": "User not found",
        "errors.user.invalid_token": "Invalid Token",
        "errors.user.invalidjsonprofileschema": "User profile schema is formatted as valid JSON",
        "errors.user.notmatchingprofileschema": "User profile does not match the defined schema",
        "errors.user.noprofileschema": "No current JSON formatted user profile schema found",
        "errors.user.notalloldkeyspresentinschema": "Not all keys of previous schema are present in schema update",
        "errors.user.newandoldtypenotmatching": "All types in the new schema must match the previous types",
        "errors.user.creationnotallowed": "Creation of new users is not allowed.",
        "errors.invitation.missingrole": "An invitation should contain at least one role",
        "errors.invitation.notenant": "No tenant found for id: ",
        "errors.invitation.notinvitable": "Invites can only be created for projects or companies.",
        "errors.verify.email.invalid_token": "Token not valid",
        "errors.verify.email.incorrect_token": "Token is incorrect",
        "errors.verify.email.email_not_found": "Email could not be found",
        "errors.verify.email.could_not_send": "Email confirmation could not be sent",
        "errors.file.unsplash.notoken": "Reseller has set no API Key for Unsplash.com.",
        "errors.file.unsplash.invalidtoken": "Token for Unsplash.com is invalid.",
        "errors.file.unsplash.limitexceeded": "Requestlimit of Unsplash.com has been exceeded.",
        "errors.file.unsplash.generalerror": "The request to Unsplash.com has resulted in an error.",
        "errors.note.noservicetoken": "ServiceTokens cannot be uses to access or edit notes.",
        "errors.note.usernotfound": "No user could be found for this note.",
        "errors.note.onlyeditpersonal": "Only personal notes can be edited.",
        "errors.note.onlyaccesspersonal": "Personal notes of others cannot be accessed.",
        "errors.note.notargetidchange": "The targetId cannot be changed or deleted.",
        "messages.errors.notinsamecompany": "You can only send messages to people in your company!",
        "messages.errors.messagenotfound": "Message could not be found.",
        "messages.errors.recipienttypenotfound": "The following recipient type could not be found: ",
        "messages.errors.recipientnotfound": "The message recipient could not be found.",
        "messages.errors.wrongreseller": "Wrong reseller for this tenant.",
        "messages.errors.isdifferentproject": "Message can not be sent to different projects.",
        "messages.errors.isnotprojectmember": "Message recipient is not a project member.",
        "messages.errors.sendingnotallowed": "Only users and projects can send messages",
        "messages.system.exportdone": "Your data export is done!",
        "messages.system.downloadexport": "Download exported data",
        "messages.system.acceptedinvitation": "has accepted your invitation.",
        "models.identifier": "Identifier",
        "models.creationdate": "Creation Date",
        "models.createdat": "Created at",
        "notes.privatehint": "Private note",
        "notes.private": "Private",
        "notifications.title": "Notifications",
        "notifications.empty": "Over here you can find current notifications. Nothing new right now.",
        "notifications.confirmation.title": "Confirmation",
        "notifications.warning.title": "Warning",
        "notifications.error.title": "Error",
        "notifications.error.message": "An error occurred!",
        "notifications.success.title": "Success",
        "notifications.added.title": "Successfully added.",
        "notifications.deleted.title": "Successfully deleted.",
        "notifications.edited.title": "Successfully edited.",
        "notifications.markedasdone.title": "Successfully marked as done.",
        "notifications.markedasopen.title": "Successfully marked as open.",
        "notifications.favorites.added": "Added to favorites.",
        "notifications.favorites.removed": "Removed from favorites.",
        "nouns.images": "Images",
        "nouns.name": "Name",
        "nouns.description": "Description",
        "nouns.creationdate": "Creation Date",
        "nouns.qrcode": "QR Code",
        "nouns.actions": "Actions",
        "nouns.preview": "Preview",
        "nouns.details": "Details",
        "nouns.value": "Value",
        "nouns.error": "Error",
        "nouns.icon": "Icon",
        "nouns.help": "Help",
        "nouns.company": "Company",
        "nouns.companyphone": "Company Phone",
        "pager.back": "back",
        "pager.next": "next",
        "pager.more": "more",
        "pager.itemsperpagelabel": "Items per Page",
        "pager.firstpagelabel": "First Page",
        "pager.nextpagelabel": "Next Page",
        "pager.previouspagelabel": "Previous Page",
        "pager.lastpagelabel": "Last Page",
        "pager.of": "of",
        "permissions.delete": "Remove all Permissions",
        "permissions.assign": "Assign standard permissions",
        "permissions.assigncustom": "Assign custom permissions",
        "permissions.errors.missing": "Missing permission '${permission}'",
        "permissions.audit.read.title": "read audit",
        "permissions.cms.write.title": "edit CMS pages",
        "permissions.cms.write.description": "This right allows to create, delete and edit CMS pages.",
        "permissions.cms.read.title": "read CMS pages",
        "permissions.cms.read.description": "This right allows to read CMS pages.",
        "permissions.checkin.admin.title": "checkin app admin",
        "permissions.checkin.admin.description": "This right allows to create, delete and edit checkin visitors, apps and configurations.",
        "permissions.checkin.read.title": "read checkin apps",
        "permissions.checkin.read.description": "This right allows to read checkin visitors, apps and configurations.",
        "permissions.custombackoffices.write.title": "edit custom backoffices",
        "permissions.custombackoffices.write.description": "This right allows to create, delete and edit custom backoffices.",
        "permissions.custombackoffices.read.title": "read custom backoffices",
        "permissions.custombackoffices.read.description": "This right allows to read custom backoffices.",
        "permissions.applications.read.title": "read Applications",
        "permissions.applications.read.description": "This right allows to read Applications.",
        "permissions.applications.write.title": "edit Applications",
        "permissions.applications.write.description": "This right allows to create, delete and edit Applications.",
        "permissions.bookedsubscriptions.write.title": "edit booked Subscriptions",
        "permissions.bookedsubscriptions.write.description": "This right allows to create, delete and edit booked Subscriptions.",
        "permissions.calendar.read.title": "read calendars",
        "permissions.calendar.read.description": "This right allows to read calendars.",
        "permissions.calendar.write.title": "edit calendars",
        "permissions.calendar.write.description": "This right allows to create, delete and edit Calendars.",
        "permissions.configuration.read.title": "read configurations",
        "permissions.configuration.read.description": "This right allows to read configurations.",
        "permissions.configuration.write.title": "edit configurations",
        "permissions.configuration.write.description": "This right allows to create, delete and edit configurations.",
        "permissions.configuration.admin.title": "configuration admin",
        "permissions.configuration.admin.description": "This right grants full access to all configration operations.",
        "permissions.contacts.read.title": "read contacts",
        "permissions.contacts.read.description": "This right allows to read contacts.",
        "permissions.contacts.write.title": "edit contacts",
        "permissions.contacts.write.description": "This right allows to create, delete and edit contacts.",
        "permissions.contacts.admin.title": "contact admin",
        "permissions.contacts.admin.description": "This right grants full access to all contact operations.",
        "permissions.cronjob.read.title": "read cronjobs",
        "permissions.cronjob.read.description": "This right allows to read cronjobs.",
        "permissions.cronjob.write.title": "edit cronjobs",
        "permissions.cronjob.write.description": "This right allows to create, delete and edit cronjobs.",
        "permissions.data.read.title": "read data",
        "permissions.data.read.description": "This right allows to read data.",
        "permissions.data.write.title": "edit data",
        "permissions.data.write.description": "This right allows to create, delete and edit data.",
        "permissions.datatypes.read.title": "read datatypes",
        "permissions.datatypes.read.description": "This right allows to read project datatypes.",
        "permissions.datatypes.write.title": "edit project datatypes",
        "permissions.datatypes.write.description": "This right allows to create, delete and edit datatypes.",
        "permissions.devices.read.title": "read devices",
        "permissions.devices.read.description": "This right allows to read devices.",
        "permissions.devices.write.title": "edit devices",
        "permissions.devices.write.description": "This right allows to create, delete and edit devices.",
        "permissions.emails.read.title": "read emails",
        "permissions.emails.read.description": "This right allows to read emails.",
        "permissions.emails.write.title": "write emails",
        "permissions.emails.write.description": "This right allows to create, delete and edit emails.",
        "permissions.emails.send.title": "send emails",
        "permissions.emails.send.description": "This right allows to send emails.",
        "permissions.emailtemplates.read.title": "read email templates",
        "permissions.emailtemplates.read.description": "This right allows to read email templates.",
        "permissions.emailtemplates.write.title": "edit email templates",
        "permissions.emailtemplates.write.description": "This right allows to create, delete and edit email templates.",
        "permissions.exporters.execute.title": "execute exporters",
        "permissions.exporters.execute.description": "This right allows to execute exporters.",
        "permissions.exporters.read.title": "read exporters",
        "permissions.exporters.read.description": "This right allows to read exporters.",
        "permissions.files.read.title": "read project files",
        "permissions.files.read.description": "This right allows to read project files.",
        "permissions.files.write.title": "edit project files",
        "permissions.files.write.description": "This right allows to create, delete and edit project files.",
        "permissions.forms.read.title": "read forms",
        "permissions.forms.read.description": "This right allows to read forms.",
        "permissions.forms.write.title": "edit forms",
        "permissions.forms.write.description": "This right allows to create, delete and edit forms.",
        "permissions.forms.admin.title": "forms admin",
        "permissions.forms.admin.description": "This right grants full access to all form operations.",
        "permissions.importers.execute.title": "execute importers",
        "permissions.importers.execute.description": "This right allows to execute importers.",
        "permissions.importers.read.title": "read importers",
        "permissions.importers.read.description": "This right allows to read importers.",
        "permissions.internationalization.read.title": "read internationalizations",
        "permissions.internationalization.read.description": "This right allows to read internationalizations.",
        "permissions.internationalization.write.title": "edit internationalizations",
        "permissions.internationalization.write.description": "This right allows to create, delete and edit internationalizations.",
        "permissions.messages.read.title": "read messages",
        "permissions.messages.read.description": "This right allows to read messages.",
        "permissions.messages.write.title": "edit messages",
        "permissions.messages.write.description": "This right allows to create, delete and edit messages.",
        "permissions.mailinglist.read.title": "read mailing lists",
        "permissions.mailinglist.read.description": "This right allows to read mailing lists.",
        "permissions.mailinglist.write.title": "edit mailing lists",
        "permissions.mailinglist.write.description": "This right allows to create, delete and edit mailing lists.",
        "permissions.mailingchannel.read.title": "read mailing channels",
        "permissions.mailingchannel.read.description": "This right allows to read mailing channels.",
        "permissions.mailingchannel.write.title": "edit mailing channels",
        "permissions.mailingchannel.write.description": "This right allows to create, delete and edit mailing channels.",
        "permissions.mailingdeliverable.read.title": "read mailing deliverables",
        "permissions.mailingdeliverable.read.description": "This right allows to read mailing deliverables.",
        "permissions.mailingdeliverable.write.title": "edit mailing deliverables",
        "permissions.mailingdeliverable.write.description": "This right allows to create, delete and edit mailing deliverables.",
        "permissions.optin.write.title": "edit optins",
        "permissions.optin.write.description": "This right allows to create, delete and edit optins.",
        "permissions.orders.read.title": "read orders",
        "permissions.orders.read.description": "This right allows to read orders.",
        "permissions.orders.write.title": "edit orders",
        "permissions.orders.write.description": "This right allows to create, delete and edit orders.",
        "permissions.permission.read.title": "read permissions",
        "permissions.permission.read.description": "This right allows to read permissions.",
        "permissions.permission.write.title": "edit permissions",
        "permissions.permission.write.description": "This right allows to create, delete and edit permissions.",
        "permissions.products.read.title": "read products",
        "permissions.products.read.description": "This right allows to read products.",
        "permissions.products.write.title": "edit products",
        "permissions.products.write.description": "This right allows to create, delete and edit products.",
        "permissions.datatemplates.write.title": "edit data templates",
        "permissions.datatemplates.write.description": "This right allows to create, delete and edit data templates.",
        "permissions.shoppingcarts.read.title": "read shopping carts",
        "permissions.shoppingcarts.read.description": "This right allows to read shopping carts.",
        "permissions.shoppingcarts.write.title": "edit shopping carts",
        "permissions.shoppingcarts.write.description": "This right allows to create, delete and edit shopping carts.",
        "permissions.suppliers.read.title": "read suppliers",
        "permissions.suppliers.read.description": "This right allows to read suppliers.",
        "permissions.suppliers.write.title": "edit suppliers",
        "permissions.suppliers.write.description": "This right allows to create, delete and edit suppliers.",
        "permissions.tasks.execute.title": "execute tasks",
        "permissions.tasks.execute.description": "This right allows to execute tasks",
        "permissions.tasks.read.title": "read tasks",
        "permissions.tasks.read.description": "This right allows to read tasks.",
        "permissions.tasks.write.title": "edit tasks",
        "permissions.tasks.write.description": "This right allows to create, delete and edit tasks.",
        "permissions.tenant.admin.title": "admin",
        "permissions.tenant.admin.description": "This right grants full access to all data and modules of a project.",
        "permissions.tenant.read.title": "read tenants (projects/companies)",
        "permissions.tenant.read.description": "This right allows to read tenants (projects/companies).",
        "permissions.tenant.write.title": "edit tenants (projects/companies)",
        "permissions.tenant.write.description": "This right allows to create, delete and edit tenants (projects/companies).",
        "permissions.company.read.title": "read company",
        "permissions.company.read.description": "This right allows to read the company.",
        "permissions.company.write.title": "edit company",
        "permissions.company.write.description": "This right allows to delete and edit the company.",
        "permissions.project.read.title": "read project",
        "permissions.project.read.description": "This right allows to read the project.",
        "permissions.project.write.title": "edit project",
        "permissions.project.write.description": "This right allows to delete and edit the project.",
        "permissions.users.read.title": "read users",
        "permissions.users.read.description": "This right allows to read users.",
        "permissions.users.write.title": "edit users",
        "permissions.users.write.description": "This right allows to create, delete and edit users.",
        "permissions.workflow.execute.title": "execute workflows",
        "permissions.workflow.execute.description": "This right allows to execute Workflows.",
        "permissions.workflow.read.title": "read workflows",
        "permissions.workflow.read.description": "This right allows to read workflows.",
        "permissions.workflow.write.title": "edit workflows",
        "permissions.workflow.write.description": "This right allows to create, delete and edit workflows.",
        "permissions.todotemplate.write": "edit todo-templates",
        "states.active": "active",
        "states.inactive": "inactive",
        "states.activated": "activated",
        "types.primitives.boolean": "true/false",
        "types.primitives.string": "Characters",
        "types.primitives.number": "Number",
        "types.customtype.singular": "projectspecific type",
        "types.customtype.plural": "projectspecific types",
        "types.customers.singular": "Customer",
        "types.customers.plural": "Customers",
        "types.applications.singular": "Application",
        "types.applications.plural": "Applications",
        "types.auditlog_records.singular": "Audit Log",
        "types.auditlog_records.plural": "Audit Logs",
        "types.subscriptions_booked.singular": "Booked Subscription",
        "types.subscriptions_booked.plural": "Booked Subscriptions",
        "types.calendars.singular": "Calendar",
        "types.calendars.plural": "Calendars",
        "types.calendarentries.singular": "Appointment",
        "types.calendarentries.plural": "Appointments",
        "types.cmspages.singular": "CMS page",
        "types.cmspages.plural": "CMS pages",
        "types.companies.singular": "Company",
        "types.companies.plural": "Companies",
        "types.configurations.singular": "Configuration",
        "types.configurations.plural": "Configurations",
        "types.contact_customfields.singular": "Custom Contact Field",
        "types.contact_customfields.plural": "Custom Contact Fields",
        "types.contacts.singular": "Contact",
        "types.contacts.plural": "Contacts",
        "types.counters.singular": "Counter",
        "types.counters.plural": "Counters",
        "types.countries.singular": "Country",
        "types.countries.plural": "Countries",
        "types.cronjobs.singular": "Cronjob",
        "types.cronjobs.plural": "Cronjobs",
        "types.custombackoffices.singular": "Projectspecific Backoffice",
        "types.custombackoffices.plural": "Projectspecific Backoffices",
        "types.dashboards.singular": "Dashboard",
        "types.dashboards.plural": "Dashboards",
        "types.datatypes.singular": "Datatype",
        "types.datatypes.plural": "Datatypes",
        "types.data.singular": "Data",
        "types.data.plural": "Data",
        "types.device_registrations.singular": "Device Registration",
        "types.device_registrations.plural": "Device Registrations",
        "types.devices.singular": "Device",
        "types.devices.plural": "Devices",
        "types.emaillayouts.singular": "Email Layout",
        "types.emaillayouts.plural": "Email Layouts",
        "types.emailtemplates.singular": "Email Template",
        "types.emailtemplates.plural": "Email Templates",
        "types.emails.singular": "Email",
        "types.emails.plural": "Emails",
        "types.files.singular": "File",
        "types.files.plural": "Files",
        "types.forms.singular": "Form",
        "types.forms.plural": "Forms",
        "types.invitations.singular": "Invitation",
        "types.invitations.plural": "Invitations",
        "types.languages.singular": "Language",
        "types.languages.plural": "Languages",
        "types.locales.singular": "Locale",
        "types.locales.plural": "Locales",
        "types.mailing_channels.singular": "Mailing Channel",
        "types.mailing_channels.plural": "Mailing Channels",
        "types.mailing_deliverable.singular": "Mailing Deliverable",
        "types.mailing_deliverable.plural": "Mailing Deliverables",
        "types.mailing_lists.singular": "Mailing List",
        "types.mailing_lists.plural": "Mailing Lists",
        "types.mailing_sent.singular": "Sent Mailing",
        "types.mailing_sent.plural": "Sent Mailings",
        "types.messages.singular": "Message",
        "types.messages.plural": "Messages",
        "types.notes.singular": "Note",
        "types.notes.plural": "Notes",
        "types.notifications.singular": "Notification",
        "types.notifications.plural": "Notifications",
        "types.optins.singular": "Opt-In",
        "types.optins.plural": "Opt-Ins",
        "types.orders.singular": "Order",
        "types.orders.plural": "Orders",
        "types.permissions.singular": "Permission",
        "types.permissions.plural": "Permissions",
        "types.pricezones.singular": "Price Zone",
        "types.pricezones.plural": "Price Zones",
        "types.products.singular": "Product",
        "types.products.plural": "Products",
        "types.datatemplates.singular": "Data Template",
        "types.datatemplates.plural": "Data Templates",
        "types.projects.singular": "Project",
        "types.projects.plural": "Projects",
        "types.resellers.singular": "Reseller",
        "types.resellers.plural": "Resellers",
        "types.roles.singular": "Role",
        "types.roles.plural": "Roles",
        "types.servicetokens.singular": "Servicetoken",
        "types.servicetokens.plural": "Servicetokens",
        "types.shoppingcarts.singular": "Shopping Cart",
        "types.shoppingcarts.plural": "Shopping Carts",
        "types.subscriptions.singular": "Subscription",
        "types.subscriptions.plural": "Subscriptions",
        "types.suppliers.singular": "Supplier",
        "types.suppliers.plural": "Suppliers",
        "types.tasks.singular": "Task",
        "types.tasks.plural": "Tasks",
        "types.translations.singular": "Translation",
        "types.translations.plural": "Translations",
        "types.todos.singular": "Todo",
        "types.todos.plural": "Todos",
        "types.todotemplates.singular": "Todo Template",
        "types.todotemplates.plural": "Todo Templates",
        "types.users.singular": "Backoffice User",
        "types.users.plural": "Backoffice Users",
        "types.visitors.singular": "Visitor",
        "types.visitors.plural": "Visitors",
        "types.visitorevents.singular": "Visitor Event",
        "types.visitorevents.plural": "Visitor Events",
        "types.printerconfigurations.singular": "Printer Configuration",
        "types.printerconfigurations.plural": "Printer Configurations",
        "types.apps.singular": "App",
        "types.apps.plural": "Apps",
        "types.workflows_executions.singular": "Workflow Execution",
        "types.workflows_executions.plural": "Workflow Executions",
        "types.workflows.singular": "Workflow",
        "types.workflows.plural": "Workflows",
        "types.worklogs.singular": "Worklog",
        "types.worklogs.plural": "Worklogs",
        "types.pdftemplates.singular": "PDF Template",
        "types.pdftemplates.plural": "PDF Templates"
    };
}
exports.common_en_us = common_en_us;
